var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex"},attrs:{"title":_vm.label}},[_c('div',{staticStyle:{"width":"3rem","height":"24rem","background":"#1C4EFD","border-radius":"92rem 92rem 92rem 92rem"}}),_c('div',{staticClass:"item-text"},[_vm._v(" "+_vm._s(_vm.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }